import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TeamDetailChip from "./TeamDetailChip";

const sectionCardSx = {
  width: "100%",
  maxWidth: 632,
  borderRadius: "8px",
  border: "1px solid #E5E9EC",
  background: "#FFF",
  p: 3,
  boxSizing: "border-box",
};

export default function TeamDetailGroupsSection({ groups }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        sx={{
          color: "#061522",
          fontFamily: "Inter",
          fontSize: 20,
          fontWeight: 500,
          lineHeight: "34px",
          mb: 1.5,
        }}
      >
        Groups
      </Typography>
      <Box sx={{ ...sectionCardSx, display: "flex", flexWrap: "wrap", gap: 1 }}>
        {groups.map((label) => (
          <TeamDetailChip key={label} label={label} />
        ))}
      </Box>
    </Box>
  );
}
